import { createContext, useCallback, useContext } from 'react';
import { VersionSource } from './useVersionHistory';

/**
 * Lets components below QuizAgentDialog (nested edit dialogs, the add/delete
 * page actions in QuizAgentChatScreen) commit a manual version without
 * threading the history hook's full API through props. Undo/redo/lock stay
 * owned by index.tsx — only the ability to push is exposed here.
 */
export interface IVersionHistoryContext {
  pushVersion: (label: string, source: VersionSource) => void;
}

export const VersionHistoryContext = createContext<IVersionHistoryContext | null>(null);

/**
 * Returns a stable no-op if called outside the provider so call sites don't
 * need to guard — mirrors usePausePreviewSync's defensive style. Wrapped in
 * useCallback so the returned function's identity only changes when the
 * provider value does, safe to include in dependency arrays.
 */
export const useCommitVersion = () => {
  const ctx = useContext(VersionHistoryContext);
  return useCallback((label: string) => {
    if (!ctx) return;
    ctx.pushVersion(label, 'manual');
  }, [ctx]);
};
